import { logger as LOG } from '@garnish/logger';

// ────────────────────────────────────────────────────────────────────────────────

export const reCaptchaLogger = LOG.extend('RECAPTCHA');
